/**
 * 브랜치 버전 종료일을 "그 날의 끝(23:59:59)"으로 변환한다.
 *
 * 배경: v1(legacy)은 종료일에 `23:59:59`를 붙여 하루 전체를 유효 범위로 저장했으나,
 * v2 마이그레이션에서 날짜만(`YYYY-MM-DD`) 전송하게 되어 BE 가 `00:00:00`으로 저장하는
 * 회귀가 발생했다. 이 함수로 v1 동작을 복원한다.
 *
 * 입력은 `"YYYY-MM-DD"`(신규 선택) 또는 BE 가 돌려준 datetime(`"YYYY-MM-DDTHH:mm:ss..."`,
 * 구형 `"YYYY.MM.DD ..."`) 어느 형태든 올 수 있어, 앞 10자리 날짜만 취해 멱등하게 처리한다.
 * (편집 시 저장→재조회→재저장 되어도 시각이 중복 append 되지 않음)
 *
 * @returns `"YYYY-MM-DD 23:59:59"` — 빈 값이면 `null` (종료일 없음)
 */
export function toValidUntil(value?: string | null): string | null {
  if (!value) return null;
  const date = value.slice(0, 10).replace(/\./g, "-");
  return `${date} 23:59:59`;
}
